// extracted by mini-css-extract-plugin
module.exports = {"text":"YZ4BbO"};